/**
 * Grabs the props we dump from the server into the DOM and exports them as a singleton.
 * This allows us to conveniently dump React server-side props into the DOM and
 * import this file into redicers, which can parse necessary props off of it and
 * and hydrate the redux store.
 */

import log from 'loglevel'

// grab the node which contains props
const serverPropsNode = document.getElementById('server-props')

// grab innerHTML (which is the props as JSON); default to strignified empty object
const serverPropsJSON = (serverPropsNode && serverPropsNode.innerHTML) || '{}'

// parse the JSON strings to JavaScript objects
// TODO: Consider wrapping these in try/catches
const serverProps = JSON.parse(serverPropsJSON)

// log the serverProps locally for easy introspection; can't dispatch a redux action
// because the store isn't ready when this file is called
log.info('INIT:p2p:serverProps', serverProps)

export default serverProps
